export default __webpack_public_path__ + "static/media/sign_up.aa74abce.jpg";